import type { AiExecutionAuthority } from '../../types/aiOperational'

const authorityLabel: Record<AiExecutionAuthority, string> = {
  CLIENT_LOCAL: 'Local guidance',
  USER_CONFIRMATION: 'User confirmation',
  AI_PROPOSAL_REVIEW: 'Line Review',
  TRUSTED_BACKEND: 'Trusted backend',
  DELTA_PROCESSOR: 'DeltaProcessor',
  AUDIT_LEDGER: 'Audit ledger',
}

export const ExecutionAuthorityPill = ({ authority }: { authority: AiExecutionAuthority }) => (
  <span className="aiExecutionAuthorityPill">{authorityLabel[authority]}</span>
)
